import { render, staticRenderFns } from "./FeatureToast.vue?vue&type=template&id=6820f763&scoped=true"
import script from "./FeatureToast.vue?vue&type=script&lang=js"
export * from "./FeatureToast.vue?vue&type=script&lang=js"
import style0 from "./FeatureToast.vue?vue&type=style&index=0&id=6820f763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6820f763",
  null
  
)

export default component.exports